import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Cookies from 'js-cookie'
import { toast } from "react-toastify";
import {
    classroomData,
    getEduspaceCalendar,
    getAllPendingClassroomRequests,
    approveClassroomRequest,
    rejectClassroomRequest,
    revokeClassroomRequest,
    bulkStatusChangeClassroomRequest,
    updateClassroomBookingTime,
    duplicateClassroomBooking,
    createClassroomRequest,
    updateClassroomRequest,
    clearClassroomSliceData,
    clearClassroomSliceStates,
} from "../../../redux/classroom/classroomSlice";
import {
    coworkData,
    getAllTowers,
    getBookingColorTypes,
    addBookingColorType,
    updateBookingColorType,
    deleteBookingColorType,
    setRequestColorType,
} from "../../../redux/cowork/coworkSlice";
import { getDashboardStats, dashboardData } from "../../../redux/dashboard/dashboardSlice";
import { toastOpts } from "../../../utils/toastConfig";
import { MODULES, selectAppModule } from "../../../redux/appModule/appModuleSlice";
import { ActionMenu, Badge, BreakerVertical, Button, Flexbox, InputField, StyledLink, WrapperBox } from "../../Theme/GlobalStyles";
import { Text } from "../../Theme/Typography";
import { globalTheme } from "../../Theme/Theme";
import { AddIcon, AngleDown, AngleLeft, AngleRight, ArrowLeft, Calender, CloseCircle, CoworkLogo, CrossSqr, MakerslabIcon, Notification, OptionVerticle, Search, TickSqr, Users } from "../../Theme/Icons";
import InitialsAvatar from "../../Components/InitialsAvatar";
import Calendly, { schoolKeyOf, schoolLabelOf, schoolColorFor } from "../../Components/Calendly";
import {
    SCHOOL_OPTIONS,
    schoolColorTypeName,
    schoolColorMapOf,
    schoolColorRowsOf,
    splitColorTypes,
} from "../../Constants/schools";
import { isModuleAdmin, getRolesFromCookie } from "../../../Routes/AdminRoute";
import { bookingWindowEnd, bookingWindowMessage, isBeyondBookingWindow } from "../../Constants/bookingWindow";
import CustomCalendar from "../../Components/CustomCalendar";
import CancelBookingPopup from "../../Components/Popup/CancelBookingPopup";
import BookingPreviewPopup from "../../Components/Popup/BookingPreviewPopup";
import { ToolTip } from "../../Components/ToolTip/ToolTip";
import { PopupBody, PopupWrapper } from "../../Components/Popup/CommonPopup";
import useLatestRequest from "../../../utils/CustomHooks/useLatestRequest";



const SegmentedToggle = ({ options, value, onChange }) => (
    <Flexbox
        alignCenter
        maxWidth="max-content"
    >
        {options.map((opt) => {
            const active = opt === value;
            return (
                <Flexbox
                    key={opt}
                    alignCenter
                    justiCenter
                    maxWidth="max-content"
                    onClick={() => onChange?.(opt)}
                    padding="5px 14px"
                    borderRadius={40}
                    className="pointer"
                    background={active ? globalTheme.colors.white1 : "transparent"}
                                >
                    <Text font12 inter medium {...(active ? {black3: true } : { nuetral13: true })}>
                        {opt}
                    </Text>
                </Flexbox>
            );
        })}
    </Flexbox>
);

const addDays = (d, n) => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
};
const startOfWeek = (d) => {
    const x = new Date(d);
    const day = x.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    x.setDate(x.getDate() + diff);
    x.setHours(0, 0, 0, 0);
    return x;
};
const formatDateLabel = (date, isWeek) => {
    if (!isWeek) {
        return date.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    }
    const start = startOfWeek(date);
    const end = addDays(start, 6);
    const startLabel = start.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    const endLabel = end.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    return `${startLabel} - ${endLabel}`;
};

const CalendarToolbar = ({
    selectedDate,
    onDateChange,
    view,
    onViewChange,
    layout,
    onLayoutChange,
    towerOptions = [],
    statusOptions = [],
    filterTower,
    filterStatus,
    onTowerChange,
    onStatusChange,
    // isClassAdmin,
    // The List View is the request-review queue (approve / reject / bulk action),
    // so it is admin-only — non-admins get the calendar with no way to switch.
    showLayoutToggle = true,
    maxDate = null,
    maxDateMessage,
}) => {
    const isWeek = view === "Week";
    const step = isWeek ? 7 : 1;
    const [calOpen, setCalOpen] = React.useState(false);

    // The board is a booking surface (drag a slot -> CreateBookingPopup), so the
    // arrows have to respect the same window the date picker does — otherwise the
    // limit is one click away from being bypassed.
    const nextDate = addDays(selectedDate, step);
    // Compare at midnight: `selectedDate` carries a time of day (the Today button
    // uses `new Date()`), which would otherwise push the last allowed day over the
    // line and make it unreachable.
    const nextMidnight = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate());
    const atMaxDate = !!maxDate && nextMidnight > maxDate;

    return (
        <Flexbox spaceBW alignCenter className="mb12" background={globalTheme.colors.white1} borderRadius={20} padding='10px 12px'>
            <Flexbox gap={10} alignCenter maxWidth="max-content">
                <WrapperBox padding="6px 10px" background={globalTheme.colors.nuetral2} borderRadius={20} overflow={'visible'}>
                    <Flexbox alignCenter gap={14}>

                        <AngleLeft className={'pointer'} color={globalTheme.colors.nuetral13}
                            onClick={() => onDateChange(addDays(selectedDate, -step))}
                        />

                        <div style={{ position: "relative" }}>
                            <WrapperBox
                                borderRadius={20}
                                padding={'4px 14px'}
                                maxWidth={'max-content'}
                                className={'pointer'}
                                onClick={() => setCalOpen((o) => !o)}
                            >
                                <Text font12 inter medium black3 style={{ padding: "0 8px" }}>
                                    {formatDateLabel(selectedDate, isWeek)}
                                </Text>
                            </WrapperBox>
                            {calOpen && (
                                <CustomCalendar
                                    align="left"
                                    selectedDate={selectedDate}
                                    maxDate={maxDate}
                                    {...(maxDateMessage ? { maxDateMessage } : {})}
                                    onSelectDate={(str) => {
                                        onDateChange(new Date(`${str}T00:00:00`));
                                        setCalOpen(false);
                                    }}
                                    onClose={() => setCalOpen(false)}
                                />
                            )}
                        </div>

                        <span
                            title={atMaxDate ? maxDateMessage : undefined}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                ...(atMaxDate ? { opacity: 0.3, cursor: 'not-allowed' } : {}),
                            }}
                        >
                            <AngleRight
                                className={atMaxDate ? '' : 'pointer'}
                                color={globalTheme.colors.nuetral13}
                                onClick={() => { if (!atMaxDate) onDateChange(nextDate); }}
                            />
                        </span>
                    </Flexbox>
                </WrapperBox>
                <WrapperBox padding="6px 10px" maxWidth={'max-content'} background={globalTheme.colors.nuetral2} borderRadius={20} className={'pointer'} onClick={() => onDateChange(new Date())}>
                    <Text font12 inter medium black3>Today</Text>
                </WrapperBox>
                <BreakerVertical marginLeft={4} marginRight={4} borderColor={globalTheme.colors.grey6} height={24} />
            </Flexbox>

            <Flexbox gap={10} alignCenter flexEnd maxWidth="50%">
                <WrapperBox padding="6px 10px" background={globalTheme.colors.nuetral2} borderRadius={20} maxWidth="max-content" overflow={'visible'} className={'pointer'}>
                    <ActionMenu
                        btnName="All Towers"
                        fontSize={12}
                        fontColor={globalTheme.colors.nuetral13}
                        menuList={towerOptions}
                        selectedValue={filterTower}
                        onSelect={(value) => onTowerChange?.(value)}
                    />
                </WrapperBox>
                
                {
                    showLayoutToggle && 
                    <WrapperBox padding="6px 10px" background={globalTheme.colors.nuetral2} borderRadius={20} maxWidth="max-content" overflow={'visible'} className={'pointer'}>
                        <ActionMenu
                            btnName="All Statuses"
                            fontSize={12}
                            fontColor={globalTheme.colors.nuetral13}
                            menuList={statusOptions}
                            selectedValue={filterStatus}
                            onSelect={(value) => onStatusChange?.(value)}
                        />
                    </WrapperBox>
                }
                {showLayoutToggle && (
                    <WrapperBox padding="6px 10px" background={globalTheme.colors.nuetral2} borderRadius={20} maxWidth="max-content">
                        <SegmentedToggle
                            options={["List View", "Calendar View"]}
                            value={layout}
                            onChange={onLayoutChange}
                        />
                    </WrapperBox>
                )}
                <WrapperBox padding="6px 10px" background={globalTheme.colors.nuetral2} borderRadius={20} maxWidth="max-content">

                    <SegmentedToggle
                        options={["Day", "Week"]}
                        value={view}
                        onChange={onViewChange}
                    />
                </WrapperBox>
            </Flexbox>
        </Flexbox>
    );
};

const SKELETON_BAR = {
    display: "block",
    height: 14,
    borderRadius: 6,
    background: "linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    // Keyframes live in GlobalStyles.
    animation: "shimmer 1.5s infinite",
};

// Shimmer row shaped like a real request row, so the table doesn't jump when
// the data lands. Used for the first load and for each infinite-scroll page.
const BookingSkeletonRow = () => (
    <tr>
        <td>
            <div className="tabBox">
                <span style={{ ...SKELETON_BAR, width: 16, height: 16, borderRadius: 4 }} />
            </div>
        </td>
        <td>
            <div className="tabBox">
                <span style={{ ...SKELETON_BAR, width: 28, height: 28, borderRadius: "50%" }} />
                <span style={{ ...SKELETON_BAR, width: 110 }} />
            </div>
        </td>
        {[90, 150, 170, 40].map((w, i) => (
            <td key={i}>
                <div className="tabBox">
                    <span style={{ ...SKELETON_BAR, width: w }} />
                </div>
            </td>
        ))}
        <td>
            <div className="tabBox">
                <span style={{ ...SKELETON_BAR, width: 80, height: 20, borderRadius: 20 }} />
            </div>
        </td>
        <td>
            <div className="tabBox">
                <span style={{ ...SKELETON_BAR, width: 24, height: 24, borderRadius: 12 }} />
            </div>
        </td>
    </tr>
);

const PER_PAGE = 10;
// Rooms per page in the Calendar view (each room carries its own bookings).
const CAL_PER_PAGE = 10;
// How close to the bottom of the scroller (px) before the next page is pulled.
const SCROLL_THRESHOLD = 160;
const isPendingStatus = (s) => s === "Pending" || s === "Under Review";
// A booking can only be cancelled while it is still live.
const isCancellableStatus = (s) => s === "Approved" || s === "Booked";
const CHECKBOX_STYLE = { width: 16, height: 16, cursor: "pointer", accentColor: globalTheme.colors.primary };

const statusBadgeProps = (status) => {
    if (status === "Approved") return { green: true };
    if (status === "Rejected" || status === "Cancelled") return { red: true };
    return { yellow: true };
};

// Eduspace classroom requests list — same data + approve/reject/revoke flow as
// the admin Bookings page, rendered as a clean table inside the dashboard.
const BookingsTable = ({ filterTower = "", filterStatus = "", searchQuery = "" }) => {
    const dispatch = useDispatch();
    // Page/filter changes fire fast — cancel the request each new one supersedes.
    const runLatest = useLatestRequest();
    const {
        allPendingRequestsList,
        allPendingRequestsCount,
        // List-only loading flag — the calendar shares this slice, so the generic
        // `isClassroomSliceFetching` would also be true while it loads.
        isPendingRequestsFetching,
        isClassroomSliceSmallFetching,
        isClassroomSliceSuccess,
        isClassroomSliceError,
        classroomSliceSuccessMessage,
        classroomSliceErrorMessage,
    } = useSelector(classroomData);

    const [page, setPage] = React.useState(1);
    const [rejectingRow, setRejectingRow] = React.useState(null);
    const [reason, setReason] = React.useState("");
    const [actionLoading, setActionLoading] = React.useState({});

    // Booking preview (details + comments) — opened from the Name link / row menu.
    const [previewRequest, setPreviewRequest] = React.useState(null);

    // Bulk selection
    const [selectedIds, setSelectedIds] = React.useState([]);
    const [bulkRejectOpen, setBulkRejectOpen] = React.useState(false);
    const [bulkRejectReason, setBulkRejectReason] = React.useState("");
    const [bulkActionType, setBulkActionType] = React.useState(null);

    // Infinite scroll bookkeeping (see the effects further down).
    const scrollRef = React.useRef(null);
    const [endReached, setEndReached] = React.useState(false);
    const lastLenRef = React.useRef(0);

    // Mirror the admin Bookings page payload exactly (same thunk) so the request
    // list carries the full filter shape the API expects — including the slot
    // window (startTime/endTime), which the dashboard doesn't filter on yet.
    const filterPayload = { tower: filterTower, capacity: "", availability: "", room: "", createdBy: "", status: filterStatus, startTime: "", endTime: "" };

    // The slice APPENDS each fulfilled page onto the list, which is what makes
    // infinite scroll work — so only a filter/search change (or a refresh after
    // an action) may clear it first.
    const fetchPage = (p) => {
        runLatest(getAllPendingClassroomRequests, {
            perPageCount: PER_PAGE,
            pageNumber: p,
            searchQuery,
            filters: filterPayload,
            isLab: false,
            isBmb: false,
        });
    };

    // Re-pull everything loaded so far as ONE page, so a status change doesn't
    // throw the admin back to the top of the list.
    const refreshLoaded = (upToPage) => {
        // -1 so the "added nothing → end of list" check below can't misread a
        // refresh (which lands on the same length it started from) as the end.
        lastLenRef.current = -1;
        dispatch(clearClassroomSliceData());
        runLatest(getAllPendingClassroomRequests, {
            perPageCount: PER_PAGE * upToPage,
            pageNumber: 1,
            searchQuery,
            filters: filterPayload,
            isLab: false,
            isBmb: false,
        });
    };

    // Filter/search change → back to a single fresh page.
    React.useEffect(() => {
        setPage(1);
        setSelectedIds([]);
        setEndReached(false);
        lastLenRef.current = -1;
        if (scrollRef.current) scrollRef.current.scrollTop = 0;
        dispatch(clearClassroomSliceData());
        fetchPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterTower, filterStatus, searchQuery]);

    // Load-more only; page 1 is owned by the effect above.
    React.useEffect(() => {
        if (page === 1) return;
        fetchPage(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    React.useEffect(() => {
        return () => {
            dispatch(clearClassroomSliceStates());
            dispatch(clearClassroomSliceData());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (!isClassroomSliceError) return;
        toast.error(classroomSliceErrorMessage || "That action could not be completed. Please try again.", toastOpts("eduspace-action-error"));
        setActionLoading({});
        setBulkActionType(null);
        dispatch(clearClassroomSliceStates());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClassroomSliceError, classroomSliceErrorMessage]);

    React.useEffect(() => {
        if (!isClassroomSliceSuccess) return;
        toast.success(classroomSliceSuccessMessage || "Request updated successfully.", toastOpts("eduspace-action-success"));
        setActionLoading({});
        setSelectedIds([]);
        setBulkActionType(null);
        dispatch(clearClassroomSliceStates());
        refreshLoaded(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClassroomSliceSuccess]);

    const handleApprove = (req) => {
        setActionLoading({ [req.id]: "approve" });
        dispatch(approveClassroomRequest({ requestId: req.id }));
    };
    // "Cancel Booking" is implemented as a reject (status → Rejected) so it reuses
    // an existing enum value; the backend also cancels the confirmed booking so the
    // slot frees up. Mirrors the admin Bookings page.
    const handleRevokeClick = (requestId) => {
        setActionLoading({ [requestId]: "cancel" });
        dispatch(rejectClassroomRequest({
            requestId,
            reason_for_rejection: "Cancelled by admin",
            status: "Rejected",
        }));
    };
    const openReject = (req) => {
        setRejectingRow(req);
        setReason("");
    };
    const submitReject = () => {
        if (!reason.trim()) {
            toast.error("Please enter a reason for rejecting this request.", toastOpts("eduspace-reject-reason"));
            return;
        }
        dispatch(rejectClassroomRequest({ requestId: rejectingRow.id, reason_for_rejection: reason.trim() }));
        setRejectingRow(null);
        setReason("");
    };

    // Pages are appended by the slice, so guard against a row arriving twice
    // (e.g. a request that shifted between pages while the admin scrolled).
    const rows = React.useMemo(() => {
        const seen = new Set();
        return (allPendingRequestsList || []).filter((r) => {
            if (seen.has(r.id)) return false;
            seen.add(r.id);
            return true;
        });
    }, [allPendingRequestsList]);

    // ---- Infinite scroll ----
    // The count alone isn't a safe stop condition: if a page comes back short or
    // wholly duplicated, `rows.length` would sit below the count forever and keep
    // asking for pages. So a settled load that added nothing ends the list.
    React.useEffect(() => {
        if (isPendingRequestsFetching) return;
        if (page > 1 && rows.length === lastLenRef.current) setEndReached(true);
        lastLenRef.current = rows.length;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingRequestsFetching, rows.length]);

    const hasMore = !endReached && rows.length < (allPendingRequestsCount || 0);
    // First paint (nothing on screen yet) vs. appending the next page — they get
    // different skeletons.
    const isInitialLoading = isPendingRequestsFetching && rows.length === 0;
    const isLoadingMore = isPendingRequestsFetching && rows.length > 0;

    const loadMore = React.useCallback(() => {
        if (isPendingRequestsFetching || !hasMore) return;
        setPage((p) => p + 1);
    }, [isPendingRequestsFetching, hasMore]);

    const handleScroll = (e) => {
        const el = e.currentTarget;
        if (el.scrollHeight - el.scrollTop - el.clientHeight > SCROLL_THRESHOLD) return;
        loadMore();
    };

    // A short first page can leave the table unscrollable with rows still to come
    // — top it up so there is always something to scroll to.
    React.useEffect(() => {
        const el = scrollRef.current;
        if (!el || isPendingRequestsFetching || !hasMore) return;
        if (el.scrollHeight <= el.clientHeight + SCROLL_THRESHOLD) loadMore();
    }, [rows.length, isPendingRequestsFetching, hasMore, loadMore]);

    // ---- Bulk selection + actions (mirrors the admin Bookings page) ----
    const pendingSelectedIds = selectedIds.filter((id) =>
        isPendingStatus(rows.find((r) => r.id === id)?.status)
    );
    // Rejectable = pending (Under Review) OR already approved — rejecting an
    // approved booking frees its slot again.
    const rejectableSelectedIds = selectedIds.filter((id) => {
        const status = rows.find((r) => r.id === id)?.status;
        return isPendingStatus(status) || status === "Approved";
    });
    const revokableSelectedIds = selectedIds.filter((id) => {
        const r = rows.find((x) => x.id === id);
        return r && !isPendingStatus(r.status);
    });
    const allOnPageSelected = rows.length > 0 && rows.every((r) => selectedIds.includes(r.id));

    const toggleSelectRow = (id) =>
        setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
    const toggleSelectAll = () =>
        setSelectedIds(allOnPageSelected ? [] : rows.map((r) => r.id));
    const clearSelection = () => setSelectedIds([]);

    // Send exactly the ids each button counted — passing the whole selection put
    // rows the action doesn't apply to (already approved, already rejected)
    // through the API alongside the ones that do.
    const handleBulkApprove = () => {
        if (!pendingSelectedIds.length) return;
        setBulkActionType("approve");
        dispatch(bulkStatusChangeClassroomRequest({ requestIds: pendingSelectedIds, action: "approved", reason_for_rejection: "" }));
    };
    const handleBulkRevoke = () => {
        if (!revokableSelectedIds.length) return;
        setBulkActionType("revoke");
        dispatch(bulkStatusChangeClassroomRequest({ requestIds: revokableSelectedIds, action: "revoke", reason_for_rejection: "" }));
    };
    const openBulkReject = () => {
        if (!rejectableSelectedIds.length) return;
        setBulkRejectReason("");
        setBulkRejectOpen(true);
    };
    const submitBulkReject = () => {
        if (!bulkRejectReason.trim()) {
            toast.error("Please enter a reason for rejecting this request.", toastOpts("eduspace-reject-reason"));
            return;
        }
        setBulkActionType("reject");
        // Only the pending/approved rows — already rejected or cancelled ones have
        // nothing left to reject.
        dispatch(bulkStatusChangeClassroomRequest({ requestIds: rejectableSelectedIds, action: "rejected", reason_for_rejection: bulkRejectReason.trim() }));
        setBulkRejectOpen(false);
        setBulkRejectReason("");
    };

    return (
        <WrapperBox padding={"0"} borderRadius={10} borderColor={globalTheme.colors.nuetral2} overflow={"visible"}>

            {/* Bulk action bar — appears once rows are selected. */}
            {selectedIds.length > 0 && (
                <Flexbox
                    spaceBW
                    alignCenter
                    padding="12px 20px"
                    background={globalTheme.colors.grey8}
                    style={{ borderBottom: `1px solid ${globalTheme.colors.nuetral2}` }}
                >
                    <Flexbox gap={10} alignCenter maxWidth="max-content">
                        <Text font13 inter semiBold black4>{selectedIds.length} selected</Text>
                        <Text
                            font13
                            inter
                            medium
                            grey2
                            className="pointer"
                            onClick={clearSelection}
                            style={{ textDecoration: "underline" }}
                        >
                            Clear
                        </Text>
                    </Flexbox>
                    <Flexbox gap={8} alignCenter maxWidth="max-content" flexEnd>
                        <Button
                            buttonSm
                            revIcon
                            icon={<TickSqr color={globalTheme.colors.green2} />}
                            name={`Approve (${pendingSelectedIds.length})`}
                            bgColor={globalTheme.colors.green1}
                            color={globalTheme.colors.green2}
                            onClick={handleBulkApprove}
                            disabled={!pendingSelectedIds.length || isClassroomSliceSmallFetching}
                        />
                        <Button
                            buttonSm
                            revIcon
                            icon={<CrossSqr color={globalTheme.colors.red} />}
                            name={`Reject (${rejectableSelectedIds.length})`}
                            bgColor={globalTheme.colors.primary1}
                            color={globalTheme.colors.red}
                            onClick={openBulkReject}
                            disabled={!rejectableSelectedIds.length || isClassroomSliceSmallFetching}
                        />
                    </Flexbox>
                </Flexbox>
            )}

            <div className="tableWrapper" ref={scrollRef} onScroll={handleScroll}>
                <div className="mainTable">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <div className="tabBox">
                                        <input
                                            type="checkbox"
                                            checked={allOnPageSelected}
                                            onChange={toggleSelectAll}
                                            style={CHECKBOX_STYLE}
                                            aria-label="Select all"
                                        />
                                    </div>
                                </th>
                                <th><div className="tabBox">Name</div></th>
                                <th><div className="tabBox">Room</div></th>
                                <th><div className="tabBox">Description</div></th>
                                <th><div className="tabBox">Date & Time</div></th>
                                <th><div className="tabBox">Attendees</div></th>
                                <th><div className="tabBox">Status</div></th>
                                <th><div className="tabBox">Action</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {isInitialLoading ? (
                                Array.from({ length: PER_PAGE }).map((_, i) => (
                                    <BookingSkeletonRow key={`sk-${i}`} />
                                ))
                            ) : rows.length === 0 ? (
                                <tr>
                                    <td colSpan={8}>
                                        <Flexbox justiCenter alignCenter style={{ padding: "40px 0" }}>
                                            <Text font13 inter regular nuetral6>
                                                No booking requests found
                                            </Text>
                                        </Flexbox>
                                    </td>
                                </tr>
                            ) : (
                                rows.map((req) => {
                                    const user = req.requestingUser || req.CoworkUser || {};
                                    const name = `${user.firstName || ""} ${user.lastName || ""}`.trim() || "—";
                                    const dateStr = moment.utc(req.start_time).format("MMM DD, YYYY");
                                    const timeStr = `${moment.utc(req.start_time).format("hh:mm A")} - ${moment.utc(req.end_time).format("hh:mm A")}`;
                                    const pending = isPendingStatus(req.status);
                                    // Only a live booking can be cancelled — once it is rejected or
                                    // cancelled there is nothing to act on.
                                    const cancellable = isCancellableStatus(req.status);
                                    const loading = actionLoading[req.id];
                                    return (
                                        <tr key={req.id}>
                                            <td>
                                                <div className="tabBox">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(req.id)}
                                                        onChange={() => toggleSelectRow(req.id)}
                                                        style={CHECKBOX_STYLE}
                                                        aria-label={`Select ${name}`}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Flexbox gap={10} alignCenter maxWidth="max-content">
                                                        <InitialsAvatar firstName={user.firstName} lastName={user.lastName} />
                                                        <StyledLink
                                                            color={globalTheme.colors.black4}
                                                            fontWeights="500"
                                                            className="pointer"
                                                            onClick={() => setPreviewRequest(req)}
                                                        >
                                                            {name}
                                                        </StyledLink>
                                                    </Flexbox>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Text font12 inter regular nuetral7>{req.room?.room_name || "—"}</Text>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Text font12 inter regular nuetral7>{req.meeting_title || "—"}</Text>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Flexbox gap={6} alignCenter maxWidth="max-content">
                                                        <Calender color={globalTheme.colors.nuetral6} />
                                                        <Text font12 inter regular nuetral7>{dateStr}, {timeStr}</Text>
                                                    </Flexbox>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Flexbox gap={4} alignCenter maxWidth="max-content">
                                                        <Users color={globalTheme.colors.nuetral6} />
                                                        <Text font12 inter regular nuetral7>
                                                            {String((req.attendees || []).length).padStart(2, "0")}
                                                        </Text>
                                                    </Flexbox>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Badge
                                                        statusText={pending ? "Under Review" : req.status}
                                                        borderRadius={"20px"}
                                                        small
                                                        {...statusBadgeProps(req.status)}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tabBox">
                                                    <Flexbox gap={8}>
                                                        {pending ? (
                                                            <>
                                                                <ToolTip position="Bottom" minWidth="max-content" content="Approve">
                                                                    <span
                                                                        onClick={() => !loading && handleApprove(req)}
                                                                        style={{
                                                                            opacity: loading ? 0.5 : 1,
                                                                            cursor: loading ? "not-allowed" : "pointer",
                                                                        }}
                                                                    >
                                                                        <Badge noText icon={<TickSqr />} borderRadius={"12px"} green />
                                                                    </span>
                                                                </ToolTip>
                                                                <ToolTip position="Bottom" minWidth="max-content" content="Reject">
                                                                    <span
                                                                        onClick={() => !loading && openReject(req)}
                                                                        style={{
                                                                            opacity: loading ? 0.5 : 1,
                                                                            cursor: loading ? "not-allowed" : "pointer",
                                                                        }}
                                                                    >
                                                                        <Badge noText icon={<CrossSqr />} borderRadius={"12px"} red />
                                                                    </span>
                                                                </ToolTip>
                                                            </>
                                                        ) : (
                                                            <ToolTip position="Bottom" minWidth="max-content">
                                                                <div
                                                                    style={{
                                                                        opacity: loading ? 0.5 : 1,
                                                                        cursor: loading ? "not-allowed" : "pointer",
                                                                    }}
                                                                    className="flex"
                                                                >
                                                                    <ActionMenu
                                                                        staticLabel
                                                                        btnName=""
                                                                        menuList={[
                                                                            {
                                                                                dropmenu: "View Booking",
                                                                                action: () => setPreviewRequest(req),
                                                                            },
                                                                            // A rejected/cancelled request has nothing left
                                                                            // to cancel — only an approved one does.
                                                                            ...(cancellable
                                                                                ? [
                                                                                    {
                                                                                        dropmenu: "Cancel Booking",
                                                                                        action: () => handleRevokeClick(req.id),
                                                                                    },
                                                                                ]
                                                                                : []),
                                                                        ]}
                                                                        toggleIcon={<OptionVerticle />}
                                                                    />
                                                                </div>
                                                            </ToolTip>
                                                        )}
                                                    </Flexbox>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                            {isLoadingMore &&
                                Array.from({ length: 3 }).map((_, i) => (
                                    <BookingSkeletonRow key={`sk-more-${i}`} />
                                ))}
                        </tbody>
                    </table>
                </div>
                {!isPendingRequestsFetching && !hasMore && rows.length > 0 && (
                    <Flexbox justiCenter alignCenter style={{ padding: "14px 0" }}>
                        <Text font12 inter regular nuetral6>
                            You're all caught up — {rows.length} request{rows.length > 1 ? "s" : ""}
                        </Text>
                    </Flexbox>
                )}
            </div>
            <BookingPreviewPopup
                showActive={!!previewRequest}
                request={previewRequest}
                onClose={() => setPreviewRequest(null)}
            />

            <CancelBookingPopup
                showActive={!!rejectingRow}
                mode="reject"
                onCancel={() => { setRejectingRow(null); setReason(""); }}
                onConfirm={submitReject}
                reason={reason}
                setReason={setReason}
                roomName={rejectingRow?.room?.room_name}
                bookingDate={rejectingRow?.start_time ? moment.utc(rejectingRow.start_time).format("MMM DD, YYYY") : undefined}
                bookingTime={rejectingRow ? `${moment.utc(rejectingRow.start_time).format("hh:mm A")} - ${moment.utc(rejectingRow.end_time).format("hh:mm A")}` : undefined}
                bookedBy={`${rejectingRow?.requestingUser?.firstName || ""} ${rejectingRow?.requestingUser?.lastName || ""}`.trim()}
            />

            {/* Bulk reject — one reason applied to all selected pending requests. */}
            <PopupWrapper className={bulkRejectOpen ? "active" : ""}>
                <PopupBody maxWidth={480} padding={24}>
                    <Flexbox spaceBW alignCenter>
                        <Text font18 inter semiBold white>
                            Reject {rejectableSelectedIds.length} Request{rejectableSelectedIds.length > 1 ? "s" : ""}
                        </Text>
                        <CloseCircle
                            className="pointer"
                            onClick={() => { setBulkRejectOpen(false); setBulkRejectReason(""); }}
                        />
                    </Flexbox>
                    <Flexbox style={{ height: 1, background: globalTheme.colors.white1, opacity: 0.18, margin: "16px 0" }} />
                    <Text font14 inter medium white className="mb16">
                        The same reason will be applied to all {rejectableSelectedIds.length} selected
                        request{rejectableSelectedIds.length > 1 ? "s" : ""}.
                    </Text>
                    <InputField
                        label="Reason for rejection"
                        placeholder="Enter rejection reason"
                        value={bulkRejectReason}
                        onChange={(e) => setBulkRejectReason(e.target.value)}
                    />
                    <Flexbox alignCenter gap={12} justiCenter className="mt20">
                        <Button
                            buttonMd
                            whiteFilled
                            name="Cancel"
                            onClick={() => { setBulkRejectOpen(false); setBulkRejectReason(""); }}
                        />
                        <Button buttonMd redFilled name="Confirm Rejection" onClick={submitBulkReject} />
                    </Flexbox>
                </PopupBody>
            </PopupWrapper>
        </WrapperBox>
    );
};

const toIsoDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const DEFAULT_NEW_COLOR = "#3B82F6";

// Admin panel (popup) to create / edit / delete the booking color types that
// drive the calendar's color coding. Lives inside the Eduspace dashboard.
const ColorTypesPanel = ({
    open,
    onClose,
    colorTypes,
    isMutating,
    onAdd,
    onUpdate,
    onDelete,
    schoolLegend = [],
    onSetSchoolColor,
    onResetSchoolColor,
}) => {
    const [newName, setNewName] = React.useState("");
    const [newColor, setNewColor] = React.useState(DEFAULT_NEW_COLOR);
    const [editingId, setEditingId] = React.useState(null);
    const [editName, setEditName] = React.useState("");
    const [editColor, setEditColor] = React.useState(DEFAULT_NEW_COLOR);
    // Local echo of the swatch the admin is dragging, so the picker doesn't snap
    // back to the saved value while the mutation is in flight.
    const [draftSchoolColors, setDraftSchoolColors] = React.useState({});

    React.useEffect(() => {
        if (!open) {
            setNewName("");
            setNewColor(DEFAULT_NEW_COLOR);
            setEditingId(null);
            setDraftSchoolColors({});
        }
    }, [open]);

    // A colour input streams a value for every frame of the drag, so commit on a
    // trailing debounce — one save per pick, not one per pixel.
    const savedSchoolColors = React.useMemo(() => {
        const m = {};
        schoolLegend.forEach((s) => { m[s.key] = s.custom ? s.color.bd : null; });
        return m;
    }, [schoolLegend]);
    React.useEffect(() => {
        const dirty = Object.entries(draftSchoolColors).filter(
            ([key, hex]) => hex && hex.toLowerCase() !== String(savedSchoolColors[key] || "").toLowerCase()
        );
        if (!dirty.length) return;
        const t = setTimeout(() => {
            dirty.forEach(([key, hex]) => onSetSchoolColor?.(key, hex));
        }, 450);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [draftSchoolColors, savedSchoolColors]);

    const startEdit = (t) => {
        setEditingId(t.id);
        setEditName(t.name);
        setEditColor(t.color);
    };

    const submitAdd = () => {
        if (!newName.trim()) return;
        onAdd({ name: newName.trim(), color: newColor });
        setNewName("");
        setNewColor(DEFAULT_NEW_COLOR);
    };

    const submitEdit = () => {
        if (!editName.trim()) return;
        onUpdate({ id: editingId, name: editName.trim(), color: editColor });
        setEditingId(null);
    };

    return (
        <PopupWrapper className={open ? "active" : ""}>
            <PopupBody maxWidth={520} maxHeight={640} padding={24}>
                <Flexbox spaceBW alignCenter>
                    <Text font18 inter semiBold white>Booking Colors</Text>
                    <CloseCircle className="pointer" onClick={onClose} />
                </Flexbox>
                <Flexbox style={{ height: 1, background: globalTheme.colors.white1, opacity: 0.18, margin: "16px 0" }} />

                <WrapperBox background={globalTheme.colors.white1} borderRadius={14} padding={"16px"}>
                    <Text font13 inter semiBold black3>Add a type</Text>
                    <Flexbox gap={10} alignCenter className="mt12">
                        <input
                            type="color"
                            value={newColor}
                            onChange={(e) => setNewColor(e.target.value)}
                            style={{ width: 40, height: 40, border: "none", background: "none", cursor: "pointer", flexShrink: 0 }}
                            aria-label="Pick color"
                        />
                        <InputField
                            noLabel
                            placeholder="Type name (e.g. Course)"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") submitAdd(); }}
                        />
                        <Button
                            buttonMd
                            primaryFilled
                            name={isMutating ? "…" : "Add"}
                            disabled={isMutating || !newName.trim()}
                            onClick={submitAdd}
                            maxWidth="max-content"
                        />
                    </Flexbox>
                </WrapperBox>

                <Text font13 inter semiBold white className="mt16" style={{ display: "block" }}>Booking types</Text>
                <Flexbox column gap={10} alignStart className="mt8" style={{ maxHeight: 260, overflowY: "auto" }}>
                    {(colorTypes || []).length === 0 ? (
                        <Flexbox justiCenter alignCenter style={{ width: "100%", padding: "20px 0" }}>
                            <Text font13 inter regular white>No color types yet. Add one above.</Text>
                        </Flexbox>
                    ) : (
                        colorTypes.map((t) => (
                            <WrapperBox key={t.id} background={globalTheme.colors.white1} borderRadius={12} padding={"12px"} Width="100%">
                                {editingId === t.id ? (
                                    <Flexbox gap={10} alignCenter>
                                        <input
                                            type="color"
                                            value={editColor}
                                            onChange={(e) => setEditColor(e.target.value)}
                                            style={{ width: 36, height: 36, border: "none", background: "none", cursor: "pointer", flexShrink: 0 }}
                                        />
                                        <InputField
                                            noLabel
                                            value={editName}
                                            onChange={(e) => setEditName(e.target.value)}
                                            onKeyDown={(e) => { if (e.key === "Enter") submitEdit(); }}
                                        />
                                        <Button buttonMd primaryFilled name="Save" onClick={submitEdit} maxWidth="max-content" disabled={isMutating} />
                                        <Button buttonMd name="Cancel" onClick={() => setEditingId(null)} maxWidth="max-content"
                                            style={{ background: globalTheme.colors.white1, border: `1px solid ${globalTheme.colors.nuetral2}`, color: globalTheme.colors.black4 }} />
                                    </Flexbox>
                                ) : (
                                    <Flexbox spaceBW alignCenter>
                                        <Flexbox gap={10} alignCenter maxWidth="max-content">
                                            <span style={{ width: 18, height: 18, borderRadius: "50%", background: t.color, flexShrink: 0, border: `1px solid ${globalTheme.colors.nuetral2}` }} />
                                            <Text font14 inter medium black3>{t.name}</Text>
                                            <Text font12 inter regular nuetral6>{t.color}</Text>
                                        </Flexbox>
                                        <Flexbox gap={8} alignCenter maxWidth="max-content">
                                            <Text font13 inter medium className="pointer" style={{ color: globalTheme.colors.blue2, textDecoration: "underline" }} onClick={() => startEdit(t)}>Edit</Text>
                                            <Text font13 inter medium className="pointer" style={{ color: globalTheme.colors.red, textDecoration: "underline" }} onClick={() => onDelete(t.id)}>Delete</Text>
                                        </Flexbox>
                                    </Flexbox>
                                )}
                            </WrapperBox>
                        ))
                    )}
                </Flexbox>

                {/* School colours drive the calendar: every booking is coloured by
                    the school it belongs to, and the admin picks that colour here
                    (one swatch per school). Until a school is given a colour it
                    falls back to a deterministic palette hue, shown greyed as
                    "Auto". A booking explicitly tagged with a booking type above
                    still overrides its school colour. */}
                <Flexbox style={{ height: 1, background: globalTheme.colors.white1, opacity: 0.18, margin: "16px 0" }} />
                <Flexbox spaceBW alignCenter>
                    <Text font13 inter semiBold white>School colours</Text>
                    <Text font11 inter regular white style={{ opacity: 0.6 }}>Colours every booking of that school</Text>
                </Flexbox>
                <Flexbox column gap={8} alignStart className="mt8" style={{ maxHeight: 240, overflowY: "auto" }}>
                    {schoolLegend.length === 0 ? (
                        <Text font13 inter regular white style={{ opacity: 0.7 }}>
                            No schools available.
                        </Text>
                    ) : (
                        schoolLegend.map((s) => {
                            const shown = draftSchoolColors[s.key] || s.color.bd;
                            return (
                                <WrapperBox key={s.key} background={globalTheme.colors.white1} borderRadius={12} padding={"10px 12px"} Width="100%">
                                    <Flexbox spaceBW alignCenter>
                                        <Flexbox gap={10} alignCenter maxWidth="max-content">
                                            <input
                                                type="color"
                                                value={shown}
                                                onChange={(e) =>
                                                    setDraftSchoolColors((prev) => ({ ...prev, [s.key]: e.target.value }))
                                                }
                                                style={{ width: 32, height: 32, border: "none", background: "none", cursor: "pointer", flexShrink: 0 }}
                                                aria-label={`Colour for ${s.name}`}
                                            />
                                            <Flexbox column gap={2} maxWidth="max-content">
                                                <Text font14 inter medium black3>{s.name}</Text>
                                                <Text font11 inter regular nuetral6>
                                                    {shown}{s.custom ? "" : " · Auto"}
                                                </Text>
                                            </Flexbox>
                                        </Flexbox>
                                        {s.custom && (
                                            <Text
                                                font12
                                                inter
                                                medium
                                                className="pointer"
                                                style={{ color: globalTheme.colors.red, textDecoration: "underline" }}
                                                onClick={() => {
                                                    setDraftSchoolColors((prev) => {
                                                        const next = { ...prev };
                                                        delete next[s.key];
                                                        return next;
                                                    });
                                                    onResetSchoolColor?.(s.key);
                                                }}
                                            >
                                                Reset
                                            </Text>
                                        )}
                                    </Flexbox>
                                </WrapperBox>
                            );
                        })
                    )}
                </Flexbox>
            </PopupBody>
        </PopupWrapper>
    );
};

const EduspaceDashboard = () => {
    const dispatch = useDispatch();
    // Fetches go through this instead of `dispatch` so a re-fired request cancels
    // the one it supersedes (see useLatestRequest).
    const runLatest = useLatestRequest();
    const navigate = useNavigate();
    const rolesArray = getRolesFromCookie();
    // This page is reachable by "Cowork Class User" too (see MainRoute), so every
    // admin-only surface below is gated on this one flag rather than the route.
    const isClassAdmin = isModuleAdmin(rolesArray, MODULES.EDUSPACE);
    // How far ahead this role may book: 1 month for a Class User, 6 for the
    // Operations Team. Bounds the toolbar's date picker and its forward arrow.
    const maxBookingDate = React.useMemo(() => bookingWindowEnd(isClassAdmin), [isClassAdmin]);
    const maxBookingDateMessage = bookingWindowMessage(isClassAdmin);
    // Used to let a normal user still see the requests they raised themselves.
    const currentUserId = React.useMemo(() => {
        try {
            const login = Cookies.get("loginData");
            return login ? JSON.parse(login)?.id ?? null : null;
        } catch (e) {
            return null;
        }
    }, []);
    // Calendar-only loading flag: the List view fetches from the same slice, so
    // the shared `isClassroomSliceFetching` would put the calendar in a loading
    // state for a request that isn't its own.
    const { availableClassroomsList, availableClassroomsCount, isAvailableClassroomsFetching } = useSelector(classroomData);
    const { towersList, bookingColorTypes, isColorTypeMutating, colorTypeMutationSuccess } = useSelector(coworkData);
    const { stats } = useSelector(dashboardData);
    const selectedModule = useSelector(selectAppModule);

    const [colorPanelOpen, setColorPanelOpen] = React.useState(false);
    // In-flight flag for slide-to-create, so the create popup can show a loading
    // state and stay open until the request(s) settle.
    const [isCreatingBooking, setIsCreatingBooking] = React.useState(false);
    // Same, for an in-flight details edit of an under-review request.
    const [isSavingBookingEdit, setIsSavingBookingEdit] = React.useState(false);

    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [view, setView] = React.useState("Week");
    const [layout, setLayout] = React.useState("Calendar View");

    // Calendar room paging (infinite scroll) — see fetchCalendarPage below.
    const [calendarPage, setCalendarPage] = React.useState(1);
    const [calendarEndReached, setCalendarEndReached] = React.useState(false);
    // Read inside callbacks that must not be re-created on every page change.
    const calendarPageRef = React.useRef(1);
    const lastRoomsLenRef = React.useRef(0);
    const roomsAdvanceInFlightRef = React.useRef(false);

    // Shared filters — Tower applies to both views, Status to the request list.
    const [filterTower, setFilterTower] = React.useState("");
    const [filterStatus, setFilterStatus] = React.useState("");

    // Shared search (debounced) — applies to both views.
    const [searchInput, setSearchInput] = React.useState("");
    const [searchQuery, setSearchQuery] = React.useState("");
    React.useEffect(() => {
        const t = setTimeout(() => setSearchQuery(searchInput.trim()), 400);
        return () => clearTimeout(t);
    }, [searchInput]);

    React.useEffect(() => {
        dispatch(getAllTowers({ isCLassAdmin: true, isLab: false }));
        dispatch(getBookingColorTypes());
    }, [dispatch]);

    // After any color-type mutation, refetch the list (and the calendar, so a
    // deleted type's bookings fall back to their school color immediately).
    React.useEffect(() => {
        if (colorTypeMutationSuccess) {
            dispatch(getBookingColorTypes());
        }
    }, [colorTypeMutationSuccess, dispatch]);

    // Stat cards — same counts as the admin dashboard, scoped to the active module.
    React.useEffect(() => {
        dispatch(
            getDashboardStats({
                isClassroom: selectedModule === MODULES.EDUSPACE,
                isLab: selectedModule === MODULES.MAKERSLAB,
                isBmb: selectedModule === MODULES.BLOOMBERG,
            })
        );
    }, [dispatch, selectedModule]);

    const statCards = [
        { label: "Total Rooms", value: stats?.totalRooms },
        { label: "Active Rooms", value: stats?.activeRooms },
        { label: "Today's Bookings", value: stats?.todaysBookings },
        { label: "Pending Requests", value: stats?.pendingRequests },
    ];

    const towerOptions = React.useMemo(() => {
        const seen = new Set();
        const list = [];
        (towersList || []).forEach((t) => {
            const id = t?.id ?? t?.tower;
            if (id == null || seen.has(id)) return;
            seen.add(id);
            list.push({ dropmenu: t?.tower, value: id });
        });
        return [{ dropmenu: "All Towers", value: "" }, ...list];
    }, [towersList]);

    // The colour-types list holds two kinds of row: per-booking types (tagged
    // manually on one booking) and school colours (school_id set). Split them so
    // the school rows never show up in the per-booking picker.
    const { bookingTypes, schoolColors, schoolColorRows } = React.useMemo(() => {
        const { bookingTypes: types } = splitColorTypes(bookingColorTypes);
        return {
            bookingTypes: types,
            schoolColors: schoolColorMapOf(bookingColorTypes),
            schoolColorRows: schoolColorRowsOf(bookingColorTypes),
        };
    }, [bookingColorTypes]);

    // Every school the admin can paint: the canonical list, plus any school that
    // shows up on a booking in the current view but isn't in it. Colours are read
    // through the same helper the calendar draws with, so the panel can never
    // drift from what is actually rendered.
    const schoolLegend = React.useMemo(() => {
        const seen = new Map();
        SCHOOL_OPTIONS.forEach((s) => {
            seen.set(s.value, { key: s.value, name: s.name });
        });
        (availableClassroomsList || []).forEach((room) => {
            [...(room?.room_bookings || []), ...(room?.room_booking_requests || [])].forEach((b) => {
                const key = schoolKeyOf(b);
                if (seen.has(key)) return;
                seen.set(key, { key, name: schoolLabelOf(b) });
            });
        });
        return Array.from(seen.values())
            .map((s) => ({
                ...s,
                color: schoolColorFor(s.key, schoolColors),
                // false → still on the deterministic fallback hue.
                custom: !!schoolColors[s.key],
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [availableClassroomsList, schoolColors]);

    // Save (or clear) a school's colour. Stored as a booking_color_types row
    // carrying the school FK; the backend upserts on school_id, so repeatedly
    // repainting the same school updates one row instead of piling up duplicates.
    const handleSetSchoolColor = (schoolId, hex) => {
        if (!schoolId || !hex) return;
        if (schoolColors[schoolId] === hex) return; // no-op repaint
        dispatch(
            addBookingColorType({
                name: schoolColorTypeName(schoolId),
                color: hex,
                school_id: schoolId,
            })
        );
    };
    const handleResetSchoolColor = (schoolId) => {
        const row = schoolColorRows[schoolId];
        if (!row) return;
        dispatch(deleteBookingColorType({ id: row.id }));
    };

    const statusOptions = [
        { dropmenu: "All Statuses", value: "" },
        { dropmenu: "Under Review", value: "Under Review" },
        { dropmenu: "Approved", value: "Approved" },
        { dropmenu: "Rejected", value: "Rejected" },
        { dropmenu: "Cancelled", value: "Cancelled" },
    ];

    // Fetch classroom rooms + their booked slots (Eduspace = classroom admin).
    // Day view → just the selected day; Week view → the full Mon–Sun range.
    // Only when the Calendar is shown — the List view (BookingsTable) fetches its
    // own data, and both share the classroom slice.
    //
    // Rooms load a page at a time and the calendar pulls the next page as the
    // admin scrolls: the slice REPLACES the list on page 1 and APPENDS every page
    // after it, and each room carries its own bookings, so scrolling brings in
    // both the rooms and their blocks.
    const fetchCalendarPage = React.useCallback((pageNumber, perPageCount = CAL_PER_PAGE) => {
        const isWeek = view === "Week";
        const start = isWeek ? startOfWeek(selectedDate) : selectedDate;
        const end = isWeek ? addDays(startOfWeek(selectedDate), 6) : selectedDate;
        // Only a fresh page 1 may wipe what's on screen — a "load more" must keep it.
        if (pageNumber === 1) dispatch(clearClassroomSliceData());
        
        return runLatest(getEduspaceCalendar, {
            perPageCount,
            pageNumber,
            searchValue: searchQuery,
            filters: { tower: filterTower, capacity: "", availability: "", category: "", equipment: "" },
            meetingDate: toIsoDate(start),
            endDate: toIsoDate(end),
            isStudent: false,
            isAdmin: false,
            isClassAdmin: true,
            isLab: false,
        });
    }, [dispatch, runLatest, selectedDate, view, filterTower, searchQuery]);

    // Re-pull every room page loaded so far as ONE request, so an edit doesn't
    // shrink the calendar back to the first page under the admin's scroll.
    const refreshCalendar = React.useCallback(() => {
        lastRoomsLenRef.current = -1;
        return fetchCalendarPage(1, CAL_PER_PAGE * calendarPageRef.current);
    }, [fetchCalendarPage]);

    // Date / view / tower / search change → start the room list over.
    React.useEffect(() => {
        if (layout !== "Calendar View") return;
        setCalendarPage(1);
        setCalendarEndReached(false);
        lastRoomsLenRef.current = -1;
        roomsAdvanceInFlightRef.current = false;
        fetchCalendarPage(1);
        return () => {
            dispatch(clearClassroomSliceStates());
            dispatch(clearClassroomSliceData());
        };
    }, [dispatch, fetchCalendarPage, layout]);

    // Load-more only; page 1 is owned by the effect above. Release the advance
    // guard only once this page's fetch settles, so the next page can't be
    // requested (and race/abort this one) while it is still in flight.
    React.useEffect(() => {
        if (layout !== "Calendar View" || calendarPage === 1) return;
        Promise.resolve(fetchCalendarPage(calendarPage)).finally(() => {
            roomsAdvanceInFlightRef.current = false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarPage]);

    React.useEffect(() => {
        calendarPageRef.current = calendarPage;
    }, [calendarPage]);

    // The room count alone isn't a safe stop condition — a page that comes back
    // short would leave the calendar asking for more forever. A settled load that
    // added no rooms ends the list.
    React.useEffect(() => {
        if (isAvailableClassroomsFetching) return;
        const len = (availableClassroomsList || []).length;
        if (calendarPageRef.current > 1 && len === lastRoomsLenRef.current) setCalendarEndReached(true);
        lastRoomsLenRef.current = len;
    }, [isAvailableClassroomsFetching, availableClassroomsList]);

    const hasMoreRooms =
        !calendarEndReached && (availableClassroomsList || []).length < (availableClassroomsCount || 0);
    const isLoadingMoreRooms =
        isAvailableClassroomsFetching && (availableClassroomsList || []).length > 0;
    const handleLoadMoreRooms = React.useCallback(() => {
        // Ignore a repeat trigger fired in the gap before the current page's
        // fetch has started (and set the loading flag). Cleared once it settles.
        if (roomsAdvanceInFlightRef.current) return;
        roomsAdvanceInFlightRef.current = true;
        setCalendarPage((p) => p + 1);
    }, []);

    // UTC fractional hour (e.g. 9.5) → "HH:mm:ss" for the naive datetime strings
    // the booking API expects.
    const fracToTime = (h) => {
        const hh = Math.floor(h);
        const mm = Math.round((h - hh) * 60);
        return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:00`;
    };

    // Build the start/end datetime strings for a block on `date`. A block that
    // runs to midnight carries an end of 0 (or 24), which would otherwise land
    // on the same day as — and before — its start; roll that end to the next day.
    const toRange = (date, start, end) => {
        const startDt = moment.utc(date, "YYYY-MM-DD").add(Math.round(start * 60), "minutes");
        let endDt = moment.utc(date, "YYYY-MM-DD").add(Math.round(end * 60), "minutes");
        if (!endDt.isAfter(startDt)) endDt = endDt.add(1, "day");
        return {
            start_time: startDt.format("YYYY-MM-DD HH:mm:ss"),
            end_time: endDt.format("YYYY-MM-DD HH:mm:ss"),
        };
    };

    // Commit all staged calendar edits when the admin hits "Save Changes":
    //   updates — resizes + moves (time and/or room) → updateClassroomBookingTime
    //   creates — pasted/Alt-dragged copies → duplicateClassroomBooking
    // Each carries UTC fractional hours; convert to "YYYY-MM-DD HH:mm:ss" here.
    // We refetch once after all of them settle so the calendar reflects the DB.
    const handleCalendarSave = ({ updates = [], creates = [] } = {}) => {
        const tasks = [];

        if (updates.length) {
            // A pending block is a request with no confirmed booking behind it,
            // so it is addressed by requestId; everything else by bookingId.
            const payload = updates.map((c) => ({
                ...(c.isRequest ? { requestId: c.requestId } : { bookingId: c.id }),
                room_id: c.room_id,
                ...toRange(c.date, c.start, c.end),
            }));
            tasks.push(dispatch(updateClassroomBookingTime({ updates: payload })).unwrap());
        }

        creates.forEach((c) => {
            tasks.push(
                dispatch(duplicateClassroomBooking({
                    sourceBookingId: c.sourceBookingId,
                    // Set instead when the copied block was a pending request.
                    sourceRequestId: c.sourceRequestId,
                    room_id: c.room_id,
                    ...toRange(c.date, c.start, c.end),
                })).unwrap()
            );
        });

        if (!tasks.length) return;
        // allSettled: one rejected duplicate (e.g. a server-side conflict) must
        // not stop the others or the refetch.
        Promise.allSettled(tasks).then((results) => {
            // A class user's edits don't land as-is — a re-timed booking goes back
            // to "Under Review" and a pasted copy becomes a request — so surface
            // whatever the API reported rather than letting the blocks silently
            // change shape after the refetch.
            const failed = results.filter((r) => r.status === "rejected");
            if (failed.length) {
                toast.error(
                    failed[0].reason?.message || "Some changes could not be saved.",
                    { autoClose: 3500 }
                );
            } else if (!isClassAdmin) {
                toast.success("Your changes were sent for admin approval.", {
                    autoClose: 3500,
                });
            }
            refreshCalendar();
        });
    };

    // "View Requests" on a booking's hover → open the Bookings page filtered to
    // that room + slot, so the admin can review every request for it. The page
    // reads these from router state (same pattern as its roomId/roomName link).
    const handleViewRequests = ({ roomId, roomName, date, start, end }) => {
        navigate("/user-bookings", {
            state: {
                roomId: roomId != null ? roomId : "",
                roomName: roomName || "",
                startTime: `${date} ${fracToTime(start)}`,
                endTime: `${date} ${fracToTime(end)}`,
            },
        });
    };

    // Slide-to-create on the calendar → one createClassroomRequest per occurrence
    // date (recurrence is expanded in the calendar). The backend auto-approves for
    // class admins (→ Booked) and sets normal users to "Under Review". While the
    // requests are in flight we flip `isCreatingBooking` so the popup can show a
    // loading state, and only on success do we refetch the calendar (so the new
    // bookings/requests appear, solid or dashed by status) and resolve — letting
    // the popup close. Rejecting propagates the failure so the popup stays open.
    const handleCreateBooking = async ({ room_id, dates = [], slot, meeting_title, attendees = [], school, needInstructor = false, isEvent = false }) => {
        if (!room_id || !dates.length) return;
        // Backstop for the toolbar's maxDate — a multi-day slide or a stale board
        // date must not place a request past this role's booking window.
        if (dates.some((d) => isBeyondBookingWindow(d, isClassAdmin))) {
            toast.error(bookingWindowMessage(isClassAdmin), { autoClose: 3500 });
            return Promise.reject(new Error("outside booking window"));
        }
        setIsCreatingBooking(true);
        try {
            const results = await Promise.allSettled(
                dates.map((date) =>
                    dispatch(
                        createClassroomRequest({
                            room_id,
                            date,
                            slot,
                            meeting_title,
                            school_id: school || "Masters Union",
                            attendees,
                            equipments: [],
                            needInstructor,
                            isEvent,
                        })
                    ).unwrap()
                )
            );
            const anyFulfilled = results.some((r) => r.status === "fulfilled");
            const anyRejected = results.some((r) => r.status === "rejected");
            // Refetch whenever at least one request landed, so successful ones show
            // up even if a sibling occurrence conflicted.
            if (anyFulfilled) await refreshCalendar();
            // If every occurrence failed, surface it so the popup keeps the form.
            if (!anyFulfilled && anyRejected) throw new Error("create-failed");
        } finally {
            setIsCreatingBooking(false);
        }
    };

    // Edit the details of a request that is still "Under Review" — same form and
    // same payload as create, routed to the update endpoint. The calendar only
    // offers this on a pending request the viewer owns (or any pending one, for
    // an admin), so an approved or rejected booking can't be re-edited here.
    // Rejecting propagates the failure so the popup stays open with the form.
    const handleEditBooking = async ({ requestId, room_id, date, slot, meeting_title, attendees = [], school, needInstructor = false, isEvent = false }) => {
        if (!requestId) return;
        setIsSavingBookingEdit(true);
        try {
            await dispatch(
                updateClassroomRequest({
                    requestId,
                    room_id,
                    date,
                    slot,
                    meeting_title,
                    school_id: school || "Masters Union",
                    attendees,
                    equipments: [],
                    needInstructor,
                    isEvent,
                })
            ).unwrap();
            toast.success("Booking request updated.", toastOpts("eduspace-edit-success"));
            await refreshCalendar();
        } catch (e) {
            toast.error(
                e?.message || "Those changes could not be saved. Please try again.",
                toastOpts("eduspace-edit-error")
            );
            throw e;
        } finally {
            setIsSavingBookingEdit(false);
        }
    };

    // Admin cancels an already-booked slot from the calendar popup. Implemented
    // as a reject (status → Rejected) so it reuses an existing status value; the
    // backend also cancels the confirmed booking. Refresh so the slot frees up.
    const handleCancelBooking = (requestId, reason) => {
        if (!requestId) return;
        dispatch(rejectClassroomRequest({
            requestId,
            reason_for_rejection: reason?.trim() || "Cancelled by admin",
            status: "Rejected",
        }))
            .unwrap()
            .catch(() => {})
            .finally(() => refreshCalendar());
    };

    // Admin tags (or clears) a booking's color type from the calendar details
    // popup. Refetch the calendar so the block recolors from the new type.
    const handleAssignColorType = (requestId, colorTypeId) => {
        if (!requestId) return;
        dispatch(setRequestColorType({ requestId, color_type_id: colorTypeId }))
            .unwrap()
            .catch(() => {})
            .finally(() => refreshCalendar());
    };

    return (
        <>
            <WrapperBox padding={'12px 20px'} background={globalTheme.colors.white1} boxShadow overflow={'visible'}>
                <Flexbox spaceBW alignCenter>
                    <Flexbox maxWidth='max-content'>
                        {/* <WrapperBox background={globalTheme.colors.grey8} padding={'8px 12px'} borderRadius={50} borderColor={globalTheme.colors.grey6} Width={'168px'} maxHeight={'max-content'} className={'pointer'} overflow={'visible'}>

                            <ActionMenu btnName="Eduspace"
                                menuList={[
                                    {
                                        dropmenu: "Makers Lab",
                                        subMenu: 'For Lab bookings',
                                        icon: <MakerslabIcon />,
                                        action: () => console.log("Makers clicked")
                                    },
                                    {
                                        dropmenu: "CoWork",
                                        subMenu: "For meeting room bookings",
                                        icon: <CoworkLogo />,
                                        route: ""
                                    }
                                ]} />
                        </WrapperBox> */}
                        <BreakerVertical marginLeft={16} marginRight={16} borderColor={globalTheme.colors.grey6} />
                        <Flexbox column justiCenter maxWidth='max-content'>
                            <Text font16 inter semiBold black3>Dashboard</Text>
                            <Text font14 inter regular grey2>Good Morning, John -- Thursday, 5 March 2026</Text>
                        </Flexbox>
                    </Flexbox>
                    <Flexbox maxWidth={'40%'} flexEnd gap={18}>
                        <InputField
                            noLabel
                            hasIcon={<Search />}
                            placeholder='Search rooms, bookings ...'
                            revIcon
                            maxWidth='300px'
                            autoFocus
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            onKeyDown={() => {}}
                        />
                        <WrapperBox padding={'9px'} borderColor={globalTheme.colors.nuetral2} borderRadius={30} maxWidth={'40px'} Height={'40px'}>
                            <Notification color={globalTheme.colors.grey3} />
                        </WrapperBox>
                    </Flexbox>
                </Flexbox>
            </WrapperBox>
            <WrapperBox background={'transparent'} maxHeight={'calc(100% - 75px)'}>
                <Flexbox spaceBW alignCenter className="mb20">
                    <Flexbox column gap={4} maxWidth="max-content">
                        <Text font24 inter semiBold black3>Classroom Schedules</Text>
                        {/* <Text font13 inter medium nuetral6>26 classrooms · Week 10, 2026</Text> */}
                    </Flexbox>
                    <Flexbox gap={12} maxWidth="max-content" alignCenter>
                        {isClassAdmin && (
                            <Button
                                buttonMd
                                name="Manage Colors"
                                onClick={() => setColorPanelOpen(true)}
                                style={{
                                    whiteSpace: "nowrap",
                                    background: globalTheme.colors.white1,
                                    border: `1px solid ${globalTheme.colors.nuetral2}`,
                                    color: globalTheme.colors.black4,
                                }}
                            />
                        )}
                        {/* <Button
                            buttonMd
                            primaryFilled
                            icon={<AddIcon color={globalTheme.colors.white1} />}
                            revIcon
                            name="New Booking"
                        /> */}
                    </Flexbox>
                </Flexbox>
                {
                    isClassAdmin &&
                    <Flexbox gap={12} alignStart className="mb20">
                        {statCards.map((card, index) => (
                            <WrapperBox key={index} borderColor={globalTheme.colors.nuetral2} borderRadius={20} maxWidth={'25%'}>
                                <Flexbox alignStart spaceBW>
                                    <Flexbox column gap={12} maxWidth='max-content'>
                                        <Text font16 semiBold inter nuetral13>{card.label}</Text>
                                        <Text font20 semiBold inter black3>{String(card.value ?? 0).padStart(2, "0")}</Text>
                                    </Flexbox>
                                    <Users color={globalTheme.colors.yellow} />
                                </Flexbox>
                            </WrapperBox>
                        ))}
                    </Flexbox>
                }
                <CalendarToolbar
                    selectedDate={selectedDate}
                    onDateChange={setSelectedDate}
                    view={view}
                    onViewChange={setView}
                    layout={layout}
                    onLayoutChange={setLayout}
                    towerOptions={towerOptions}
                    statusOptions={statusOptions}
                    filterTower={filterTower}
                    filterStatus={filterStatus}
                    onTowerChange={setFilterTower}
                    onStatusChange={setFilterStatus}
                    showLayoutToggle={isClassAdmin}
                    maxDate={maxBookingDate}
                    maxDateMessage={maxBookingDateMessage}
                />
                {isClassAdmin && layout === "List View" ? (
                    <BookingsTable filterTower={filterTower} filterStatus={filterStatus} searchQuery={searchQuery} />
                ) : (
                    <Calendly
                        selectedDate={selectedDate}
                        view={view}
                        rooms={availableClassroomsList}
                        loading={isAvailableClassroomsFetching}
                        hasMoreRooms={hasMoreRooms}
                        loadingMoreRooms={isLoadingMoreRooms}
                        onLoadMoreRooms={handleLoadMoreRooms}
                        filterStatus={filterStatus}
                        onSave={handleCalendarSave}
                        // Admin-only: "View Requests" jumps to the review queue on
                        // /user-bookings, which is itself admin-guarded. Passing
                        // undefined removes the button from the hover tooltip.
                        onViewRequests={isClassAdmin ? handleViewRequests : undefined}
                        onCreateBooking={handleCreateBooking}
                        creatingBooking={isCreatingBooking}
                        // Under-review requests stay editable (own request for a
                        // class user, any of them for an admin); the calendar
                        // hides the button once a request is decided.
                        onEditBooking={handleEditBooking}
                        savingBookingEdit={isSavingBookingEdit}
                        onCancelBooking={isClassAdmin ? handleCancelBooking : undefined}
                        colorTypes={bookingTypes}
                        schoolColors={schoolColors}
                        onAssignColorType={isClassAdmin ? handleAssignColorType : undefined}
                        canViewPending={isClassAdmin}
                        currentUserId={currentUserId}
                        isisClassAdmin={isClassAdmin}
                        isClassAdmin={isClassAdmin}
                        maxBookingDate={maxBookingDate}
                        maxBookingDateMessage={maxBookingDateMessage}
                    />
                )}
            </WrapperBox>

            <ColorTypesPanel
                schoolLegend={schoolLegend}
                open={isClassAdmin && colorPanelOpen}
                onClose={() => setColorPanelOpen(false)}
                colorTypes={bookingTypes}
                isMutating={isColorTypeMutating}
                onAdd={({ name, color }) => dispatch(addBookingColorType({ name, color }))}
                onUpdate={({ id, name, color }) => dispatch(updateBookingColorType({ id, name, color }))}
                onDelete={(id) => dispatch(deleteBookingColorType({ id }))}
                onSetSchoolColor={handleSetSchoolColor}
                onResetSchoolColor={handleResetSchoolColor}
            />
        </>
    );
};
export default EduspaceDashboard;